var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "captcha_field" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error,
              expression: "error"
            }
          ],
          staticClass: "error"
        },
        [_vm._v(" " + _vm._s(_vm.error) + " ")]
      ),
      _vm._v(" "),
      _c("vue-recaptcha", {
        ref: "recaptcha",
        class: { "is-error": _vm.error },
        attrs: { name: "captcha", size: "invisible", sitekey: _vm.key },
        on: {
          verify: function($event) {
            return _vm.setValue($event)
          },
          expired: _vm.onExpiredReset
        },
        model: {
          value: _vm.captcha,
          callback: function($$v) {
            _vm.captcha = $$v
          },
          expression: "captcha"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3134e5bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3134e5bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/UiCaptcha.vue
// module id = 124
// module chunks = 0